import { DataTable, DateFormat, Number, Space } from "components/common"
import { useEffect, useMemo } from "react"

import { useLazyGetFeatureLogsQuery } from "features/inventory/api"
import { Row } from "antd"
import { joinBytItems, localisedValue } from "utils"
import { Separator } from "components/custom"
import { useTranslation } from "react-i18next"
import { t } from "i18next"

const columns =() => [
  { title: t("Date Updated"), dataIndex: "dateUpdated", width: 150 },
  { title: t("Updated By"), dataIndex: "updatedBy", key: "updatedBy", width: 200 },
  { title: t("Features Detail"), dataIndex: "featuresDetail", key: "featuresDetail" },
]

const FeatureLogsTable = ({ inventoryId }) => {
  const { t } = useTranslation()
  const [getFeatureLogs, { data: featureLogs, isFetching: isFetchingFeatureLogs, error: errorFeatureLogs }] =
    useLazyGetFeatureLogsQuery()

  useEffect(() => {
    getFeatureLogs({ recordId: inventoryId, record: "Feature" })
  }, [inventoryId])

  const renderFeature = feature => {
    if (feature?.length) {
      return joinBytItems(
        feature.map((e, index) => (
          <Space size={8} align="top" key={index}>
            <div>{localisedValue({ key: "Feature", object: e })}</div>
            <div className="gray-700">
              <Number
                value={e?.Amount}
                color="#9d9d9d"
                wrapValue={value => (e?.AmountType === "fixed" ? `(${value})` : `(${value}%)`)}
              />
            </div>
          </Space>
        )),
        <Separator />
      )
    } else {
      return "-"
    }
  }
  const getColumnData = data => {
    return data?.map(e => {
      return (
        <>
          <Row gutter={[10, 10]}>
            <Space size={2}>
              <div className="gray-700">{e[0]}</div> <div>{e[1] || "-"}</div>
            </Space>
          </Row>
        </>
      )
    })
  }

  const featureLogData = useMemo(() => {
    return (
      !!featureLogs?.length &&
      featureLogs.map((e, index) => {
        return {
          key: index,
          dateUpdated: <DateFormat date={e?.logDateAdded} icon={null} />,
          updatedBy: localisedValue({ key: "staffName", object: e }) || "-",
          featuresDetail: getColumnData([
            [t("Additional") + ": ", renderFeature(e?.additionalFeature)],
            [t("Fixed") + ": ", renderFeature(e?.fixedFeature)],
          ]),
        }
      })
    )
  }, [featureLogs])

  return (
    <div style={{ paddingTop: 12 }}>
      <DataTable
        columns={columns()}
        data={featureLogData || []}
        noUrlPush={true}
        stickyOffset={-16}
        loading={isFetchingFeatureLogs}
        error={errorFeatureLogs}
      />
    </div>
  )
}

export default FeatureLogsTable
